import React from "react";
import Navigator from "../../../components/navigator/Navigator";

export const CouponsSection = ({ id }: { id: string }) => {
    return (
        <>
            <div className="description">
                The Coupons system within Vuelve is designed to simplify the process of creating and distributing coupons to your clients. By leveraging auto-generated coupons combined with customizable message templates, you can efficiently send targeted offers and discounts.
            </div>
            <div className="sub-section">
                <ol>
                    <li>
                        <div>
                            <div>To get started, navigate to your <Navigator to="/templates" blank>templates</Navigator> page and click on the Coupons button.</div>
                            <div>This action opens a new panel displaying a list of all your products. Within this panel, you can select the products eligible for coupon auto-generation and to adjust the maximum discount value each coupon can offer.</div>
                        </div>
                    </li>
                    <li>
                        <div>
                            <div>Once you've set up your coupon-eligible products, close the Coupons panel and return to the templates page. Here, you can either create a new template by clicking on "Add Template" or edit an existing one.</div>
                            <div>While composing your template, you'll notice placeholder helpers that allow you to add dynamic content to your message. To include a coupon code in your template, click on a placeholder helper of type "coupon code" at the appropriate position within the template's body.</div>
                        </div>
                    </li>
                    <li>
                        <div>
                            <div>Once the template is ready to use, it will wait for the time you defined for it to be sent, check if the client's checkout contains any of the coupon-eligible products, and if so - it will send the template message.</div>
                            <div>If no coupon-eligible product found in the client's checkout, the template message will not be sent for that specific checkout.</div>
                        </div>
                    </li>
                </ol>
            </div>
            <div className="sub-section">
                <div>It's important to note that defining a list of allowed-products for auto-generated coupons is only effective if there is at least one template containing the "coupon code" placeholder. Without such a template, the auto-generated coupons cannot be utilized, and vice versa.</div>
            </div>
            <div className="sub-section">
                <div>By following these steps, you can seamlessly integrate coupon generation and distribution into your marketing efforts, enhancing customer engagement and driving sales. Should you need any assistance or further information, our support team is always available to help.</div>
            </div>
        </>
    );
}